import { render, staticRenderFns } from "./lkuCustomerDelivery.vue?vue&type=template&id=1c39f65c"
import script from "./lkuCustomerDelivery.vue?vue&type=script&lang=js"
export * from "./lkuCustomerDelivery.vue?vue&type=script&lang=js"
import style0 from "./lkuCustomerDelivery.vue?vue&type=style&index=0&id=1c39f65c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports